import { AbstractGameView } from "@lib/titan2-slingo/dist/game/view/abstract/display/AbstractGameView";
import { TitanSpine } from "@lib/titan2/dist/game/control/TitanSpine";
import { TitanSprite } from "@lib/titan2/dist/game/control/TitanSprite";
export class FeatureReelSymbol extends AbstractGameView {
    constructor(factory, landscapeProperties, portraitProperties) {
        super(factory, landscapeProperties, portraitProperties);
        this.reelIndex = 0;
    }
    create() {
        super.create();
        this.blank = TitanSprite.createSprite(this, "blank", this.landscapeProperties.bubble, this.portraitProperties.bubble);
        this.blank.alpha = 0.65;
        this.blank.visible = false;
        this.catMask = TitanSprite.createSprite(undefined, "catMask", this.landscapeProperties.catMask, this.portraitProperties.catMask);
        this.setId("BLANK");
    }
    setReelIndex(reelIndex) {
        this.reelIndex = reelIndex;
    }
    collectGold() {
        if (!(this.symbol instanceof TitanSpine)) {
            throw new Error("Symbol is not a spine");
        }
        this.symbol.play("duplicate", false, false, 0);
        this.symbol.getTrackEntry(0).alpha = 1;
    }
    setId(id) {
        if (this.symbol) {
            this.symbol.destroy();
        }
        this.removeChild(this.catMask);
        this.mask = undefined;
        if (id === "BLANK") {
            this.blank.visible = true;
            return;
        }
        this.blank.visible = false;
        if (id === "GOLD") {
            this.addChild(this.catMask);
            this.mask = this.catMask;
            this.symbol = TitanSpine.createSpine(this, "GOLD", this.landscapeProperties.fish.gold, this.portraitProperties.fish.gold);
            this.symbol.play("idle", true, false, 0);
            this.symbol.getTrackEntry(0).alpha = 0.2;
            return;
        }
        const colour = id.toLowerCase();
        this.symbol = TitanSprite.createSprite(this, `${colour}`, this.landscapeProperties.fish[colour], this.portraitProperties.fish[colour]);
    }
    getWidth() {
        return this.uiProperties.size.x;
    }
    getHeight() {
        return this.uiProperties.size.y;
    }
}
//# sourceMappingURL=FeatureReelSymbol.js.map